(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('RiskRuleDeleteController',RiskRuleDeleteController);

    RiskRuleDeleteController.$inject = ['$uibModalInstance', 'entity', 'RiskRule'];

    function RiskRuleDeleteController($uibModalInstance, entity, RiskRule) {
        var vm = this;

        vm.riskRule = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RiskRule.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
